import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/eurojackpot/spielen',
      gameEurojackpot: 'standard',
      game: 'Eurojackpot',
      description:
        'Eurojackpot online spielen am Dienstag & Freitag ✓: Zahlen und Zusatzlotterien tippen und sicher bei Ihrer Landeslotteriegesellschaft abgeben!',
      seoDescription:
        'Ihr Eurojackpot-Spielschein für Europas Millionenlotterie am Dienstag und Freitag: Eurojackpot-Zahlen individuell oder per Quick-Tipp ankreuzen, Laufzeit wählen und Eurojackpot online bei Ihrer Landeslotteriegesellschaft spielen.',
      title: 'Eurojackpot spielen | Eurolotto ► Freitag & Dienstag',
      seoHeadline: 'Eurojackpot | LOTTO.de - Spielen beim Original!',
    },
  };
}
